import classNames from 'classnames/bind';
import {
  TimeCategory,
  areaCode,
  timeCategoryCheckList,
} from 'common/modal/chart/utilChart';
import { DateFormat } from 'common/types';
import { days } from 'common/utils';
import { ICity } from 'contexts/searchParams';
import { useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

type TopInfoBoxProps = {
  position: string;
  isDeparture: boolean;
  applyDepartureTimeList: Function;
  departureTimeList: TimeCategory[];
  departureStartDate: string;
  departureCity: ICity;
  arrivalCity: ICity;
};

const timeCategoryTextMap = new Map([
  [TimeCategory.DAY, ''],
  [TimeCategory.HOUR_6_9, '06:00 ~ 09:00'],
  [TimeCategory.HOUR_9_12, '09:00 ~ 12:00'],
  [TimeCategory.HOUR_12_15, '12:00 ~ 15:00'],
  [TimeCategory.HOUR_15_18, '15:00 ~ 18:00'],
  [TimeCategory.HOUR_18_21, '18:00 ~ 21:00'],
  [TimeCategory.HOUR_21_24, '21:00 ~ 24:00'],
]);
enum AllTimeText {
  DEPARTURE = '가는 날 전체',
  RETURN = '오는 날 전체',
}

const TopInfoBox = ({
  position,
  isDeparture,
  applyDepartureTimeList,
  departureTimeList,
  departureStartDate,
  departureCity,
  arrivalCity,
}: TopInfoBoxProps) => {
  const [isShowFilterTime, setIsShowFilterTime] = useState(false);
  const [selectedTimeList, setSelectedTimeList] = useState(departureTimeList);

  const clickTimeHandler = (code: TimeCategory) => {
    if (code === TimeCategory.DAY) {
      return setSelectedTimeList([TimeCategory.DAY]);
    }
    // 시간일때
    let filteredList = selectedTimeList.filter(
      item => item !== TimeCategory.DAY,
    );
    if (selectedTimeList.includes(code)) {
      filteredList = filteredList.filter(item => item !== code);
    } else {
      filteredList = [...filteredList, code];
    }
    if (filteredList.length === 0) filteredList = [TimeCategory.DAY];
    setSelectedTimeList(filteredList);
  };

  return (
    <div className={cx('info')}>
      <div className={cx('inner')}>
        <div className={cx('routes')}>
          <span className={cx('start')}>
            <i className={cx('name')}>{departureCity.name}</i>
            <b className={cx('code')}>{departureCity.code}</b>
          </span>
          <span className={cx('end')}>
            <i className={cx('name')}>{arrivalCity.name}</i>
            <b className={cx('code')}>{arrivalCity.code}</b>
          </span>
        </div>
        <div className={cx('schedule')}>
          <b className={cx('date')}>
            {days(departureStartDate).format(DateFormat.DotMDd)}
          </b>
          <b className={cx('time')}>
            {departureTimeList
              .sort()
              .map(timeCode => {
                if (timeCode === TimeCategory.DAY) {
                  return isDeparture
                    ? AllTimeText.DEPARTURE
                    : AllTimeText.RETURN;
                }
                return timeCategoryTextMap.get(timeCode);
              })
              .join(', ')}
          </b>
          <button
            className={cx('select')}
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.domdepft`}
            onClick={() => {
              setIsShowFilterTime(!isShowFilterTime);
            }}
          >
            출발시각
          </button>
          {isShowFilterTime && (
            <div className={cx('options')}>
              <div className={cx('list')}>
                {timeCategoryCheckList.map((timeCode, i) => (
                  <button
                    key={`${timeCode}_${i}`}
                    className={cx('option')}
                    type="button"
                    role="checkbox"
                    aria-checked={selectedTimeList.includes(timeCode)}
                    data-event-nlog="click"
                    data-event-area-code={`${areaCode}.domdeptime`}
                    onClick={() => {
                      clickTimeHandler(timeCode);
                    }}
                  >
                    {timeCode === TimeCategory.DAY
                      ? isDeparture
                        ? AllTimeText.DEPARTURE
                        : AllTimeText.RETURN
                      : timeCategoryTextMap.get(timeCode)}
                  </button>
                ))}
              </div>
              <div className={cx('btns')}>
                <button
                  className={cx('cancel')}
                  type="button"
                  data-event-nlog="click"
                  data-event-area-code={`${areaCode}.domcancelft`}
                  onClick={() => {
                    setIsShowFilterTime(false);
                  }}
                >
                  취소
                </button>
                <button
                  className={cx('confirm')}
                  type="button"
                  data-event-nlog="click"
                  data-event-area-code={`${areaCode}.domapplyft`}
                  onClick={() => {
                    setIsShowFilterTime(false);
                    applyDepartureTimeList(isDeparture, selectedTimeList);
                  }}
                >
                  적용
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopInfoBox;
